'use client';

import { Box, MenuItem, MenuList } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { FC, ReactNode } from 'react';

import { Logo } from '../Logo';

import { MenuItemContent } from './MenuItemContent';
import styles from './Sidebar.module.scss';
import { useAuthMenu } from './use-auth-menu';
import { useGuestMenu } from './use-guest-menu';
import { useNavMenu } from './use-nav-menu';

export type SidebarProps = {
  isAuthorized: boolean;
};

export interface MenuListItem {
  title?: string;
  target?: string;
  icon?: ReactNode;
  demo?: boolean;
  onClick?: () => unknown;
}

export type MenuListItems = MenuListItem[];

export const Sidebar: FC<SidebarProps> = (props) => {
  const { isAuthorized } = props;

  const theme = useTheme();

  const guestMenu = useGuestMenu();
  const authMenu = useAuthMenu();
  const navMenu = useNavMenu();

  return (
    <div className={styles.sidebarWrapper}>
      <Box className={styles.sidebarContent} sx={{ background: theme.palette.grey[500] }}>
        <Logo />
        {isAuthorized ? (
          <>
            <MenuList className={styles.sidebarNav}>
              {navMenu.map((listItem, index) => (
                <MenuItem dense={true} key={index} className={listItem.demo ? 'demoLink' : undefined}>
                  <MenuItemContent item={listItem} />
                </MenuItem>
              ))}
            </MenuList>

            <MenuList className={styles.sidebarNav}>
              {authMenu.map((listItem, index) => (
                <MenuItem key={index} className={listItem.demo ? 'demoLink' : undefined}>
                  <MenuItemContent item={listItem} />
                </MenuItem>
              ))}
            </MenuList>
          </>
        ) : (
          <>
            <MenuList className={[styles.sidebarNav, styles.sidebarNavTop].join(' ')}>
              {guestMenu.map((listItem, index) => (
                <MenuItem key={index} className={listItem.demo ? 'demoLink' : undefined}>
                  <MenuItemContent item={listItem} />
                </MenuItem>
              ))}
            </MenuList>
          </>
        )}
      </Box>
    </div>
  );
};
